import roomApi from '@/api/room'

const room={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    editRoom:{},
    sorter:{},
    schools:[],
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,data)=>{
      state.disabled=false
      state.editRoom=data
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setSchools:(state,schools)=>{
      state.schools=schools
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await roomApi.getAll(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },room){
      try{
        if(room.id){
          await roomApi.update(room)          
        }else{
          await roomApi.create(room)
        }
        commit('edit',{})
        await dispatch('GetAll',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async Delete({ dispatch,state },room){
      await roomApi.delete(room.id)
      await dispatch('GetAll',state.pagination)
    },
    async GetSchools({ commit }){
      const res=await roomApi.getSchools()
      commit('setSchools',res.result.items)
    }
  }
}
export default room